import { useEffect } from "react";
import { useRecoilState, useRecoilValue, useResetRecoilState } from "recoil";
import * as state from "../state";
import { fetchWord } from "../api";
import { Text } from "@chakra-ui/react";

const Countdown = () => {
  const [seconds, setSeconds] = useRecoilState(state.remainingTime);
  const [data, setData] = useRecoilState(state.data);
  const setDataDefault = useResetRecoilState(state.data);
  const isPause = useRecoilValue(state.isPause);
  const refreshTime = useRecoilValue(state.refreshTime);

  useEffect(() => {
    let interval = setInterval(async () => {
      if (!isPause) {
        if (seconds === refreshTime) {
          // fetching data
          let wordData = await fetchWord();
          setDataDefault();
          if (wordData.success) {
            setData(wordData.data);
          }
        }

        setSeconds(seconds - 1);

        if (seconds === 0) {
          setSeconds(refreshTime);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds, isPause]);

  return <Text fontSize="x-large">{seconds}</Text>;
};

export default Countdown;
